import * as yup from "yup";
import { useTranslation } from "react-i18next";

export const appl33ValidationSchema = () => {
  const { t } = useTranslation();
  return yup.object().shape({
    d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    boardDate: yup.date().typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")).required(t("Το πεδίο είναι υποχρεωτικό")),
    fudocInvitation: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
  });
};
